"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
/* DESTRUCTURING */
const { apply } = Reflect, { clone, isEqual } = utils_1.default;
/* FALLBACK */
// This works with everything, but involves cloning and comparing objects, which can be really expensive
const fallback = (method, thisArg, thisArgTarget, args) => {
    const cloned = clone(thisArgTarget), result = apply(method, thisArg, args), changed = !isEqual(cloned, thisArgTarget);
    return [result, changed];
};
/* EXPORT */
exports.default = fallback;
